var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 80,
    viewBox: "0 0 70 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43692_17076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M62 78.5H18C14.4101 78.5 11.5 75.5899 11.5 72V8C11.5 4.41015 14.4101 1.5 18 1.5H44.3787L68.5 25.6213V72C68.5 75.5899 65.5899 78.5 62 78.5Z",
    fill: "white",
    stroke: "#C8D2E1",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 2V20C44 23.3137 46.6863 26 50 26H68",
    stroke: "#C8D2E1",
    strokeWidth: 3,
    strokeLinecap: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 38,
    width: 48,
    height: 32,
    rx: 4,
    fill: "#0DB664"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.17273 46.4545L12.106 51.4119H12.2196L15.167 46.4545H18.6401L14.2011 53.7273L18.7395 61H15.2026L12.2196 56.0355H12.106L9.12301 61H5.60028L10.1528 53.7273L5.68551 46.4545H9.17273ZM20.1861 61V46.4545H23.2614V58.4645H29.4972V61H20.1861ZM39.0244 50.6378C38.9675 50.0649 38.7237 49.6198 38.2928 49.3026C37.862 48.9853 37.2772 48.8267 36.5386 48.8267C36.0367 48.8267 35.6129 48.8977 35.2673 49.0398C34.9216 49.1771 34.6565 49.3688 34.4718 49.6151C34.2919 49.8613 34.2019 50.1406 34.2019 50.4531C34.1924 50.7135 34.2469 50.9408 34.3653 51.1349C34.4884 51.3291 34.6565 51.4972 34.8695 51.6392C35.0826 51.7765 35.3288 51.8973 35.6082 52.0014C35.8875 52.1009 36.1858 52.1861 36.5031 52.2571L37.8099 52.5696C38.4443 52.7116 39.0267 52.901 39.557 53.1378C40.0873 53.3745 40.5466 53.6657 40.9349 54.0114C41.3231 54.357 41.6238 54.7642 41.8369 55.233C42.0547 55.7017 42.1659 56.2391 42.1707 56.8452C42.1659 57.7353 41.9387 58.5071 41.4889 59.1605C41.0438 59.8092 40.3998 60.3134 39.557 60.6733C38.719 61.0284 37.7081 61.206 36.5244 61.206C35.3501 61.206 34.3274 61.026 33.4562 60.6662C32.5897 60.3063 31.9126 59.7737 31.4249 59.0682C30.942 58.358 30.6887 57.4796 30.665 56.4332H33.6408C33.674 56.9209 33.8137 57.3281 34.0599 57.6548C34.3108 57.9768 34.6446 58.2206 35.0613 58.3864C35.4827 58.5473 35.9585 58.6278 36.4888 58.6278C37.0097 58.6278 37.4619 58.5521 37.8454 58.4006C38.2336 58.2491 38.5343 58.0384 38.7474 57.7685C38.9604 57.4986 39.067 57.1884 39.067 56.8381C39.067 56.5114 38.9699 56.2367 38.7758 56.0142C38.5864 55.7917 38.307 55.6023 37.9377 55.446C37.5731 55.2898 37.1257 55.1477 36.5954 55.0199L35.0116 54.6222C33.7853 54.3239 32.817 53.8575 32.1067 53.223C31.3965 52.5885 31.0438 51.7339 31.0485 50.6591C31.0438 49.7784 31.2781 49.009 31.7516 48.3509C32.2299 47.6927 32.8856 47.179 33.719 46.8097C34.5523 46.4403 35.4993 46.2557 36.5599 46.2557C37.6394 46.2557 38.5817 46.4403 39.3866 46.8097C40.1962 47.179 40.826 47.6927 41.2758 48.3509C41.7256 49.009 41.9576 49.7713 41.9718 50.6378H39.0244Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43692_17076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 80,
    fill: "white",
    transform: "translate(10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.58b6d27956a66d395838e5b3173c8fcb.svg";
export { ForwardRef as ReactComponent };